import { escapeHtml } from '@/common/utils/strings'

/**
 * @param {number} maxLength
 * @returns {function(*): boolean}
 */
export function maxEscapedLength (maxLength) {
  return (value) => escapeHtml(value).length <= maxLength
}
